import { render, staticRenderFns } from "./oilProductList.vue?vue&type=template&id=e3260c60"
import script from "./oilProductList.vue?vue&type=script&lang=js"
export * from "./oilProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports